import { render } from "./mainFrame.vue?vue&type=template&id=05793f52&scoped=true"
import script from "./mainFrame.vue?vue&type=script&lang=js"
export * from "./mainFrame.vue?vue&type=script&lang=js"

import "./mainFrame.vue?vue&type=style&index=0&id=05793f52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05793f52"]])

export default __exports__